import { apiGetRequest } from 'utils/http/apiHttp';

const apiUser = {
  getCurrentUser: async () => {
    const respUser = await apiGetRequest(`user`, `withRoles=1`);

    if (respUser.status !== 200) {
      throw new Error(`Login error can't get user info`);
    }

    const respUserCapabilities = await apiGetRequest(`access/capabilities`);

    if (respUserCapabilities.status !== 200) {
      throw new Error(`Login error can't get user info`);
    }

    const userInfo = respUser?.json?.user;
    const userCapabilities = respUserCapabilities?.json?.capabilities;

    return {
      ...userInfo,
      userCapabilities,
    };
  },
};

export default apiUser;
